import React from "react";
import {CHART} from "./tokens";
import {fmtMoneyShort, fmtDay} from "./format";

/**
 * Pure-SVG daily revenue bars (no Recharts). `daily` must be the row's own array (referentially stable) so the memo holds.
 * Last bar full blue, earlier bars at 50 %, zero days a 1 px grey tick, partial last day outlined dashed.
 */
const MiniBars = React.memo(function MiniBars({
    daily, width = 84, height = 20, gap = 2, partialLast = false, label, metric = "rev", radius = 1,
}) {
    const n = Array.isArray(daily) ? daily.length : 0;
    if (!n) return <svg width={width} height={height} aria-hidden="true"/>;
    const g = n > 20 ? 1 : gap;
    const bw = Math.max(1, (width - g * (n - 1)) / n);
    let max = 0;
    for (let i = 0; i < n; i++) max = Math.max(max, Number(daily[i][metric]) || 0);
    const title = label || `${n} days: ${daily.map((d) => `${fmtDay(d.day)} ${fmtMoneyShort(d[metric])}`).join(", ")}`;
    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} role="img" aria-label={title} style={{display: "block"}}>
            <title>{title}</title>
            {daily.map((d, i) => {
                const v = Number(d[metric]) || 0;
                const x = i * (bw + g);
                const isLast = i === n - 1;
                if (v <= 0 || max <= 0) {
                    return <rect key={d.day || i} x={x} y={height - 1} width={bw} height={1} fill={CHART.zeroTick}/>;
                }
                const h = Math.max(1, Math.round((v / max) * (height - 1)));
                if (isLast && partialLast) {
                    return (
                        <rect key={d.day || i} x={x + 0.5} y={height - h + 0.5} width={Math.max(1, bw - 1)} height={Math.max(1, h - 1)}
                              fill="none" stroke={CHART.bar} strokeWidth={1} strokeDasharray="2 1.5" rx={radius}/>
                    );
                }
                return (
                    <rect key={d.day || i} x={x} y={height - h} width={bw} height={h} rx={radius}
                          fill={isLast ? CHART.bar : CHART.barPrev}/>
                );
            })}
        </svg>
    );
});

export default MiniBars;
